export default "__VITE_PUBLIC_ASSET__81ddeaa6__"